import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import getSummaryQuery from './query'
import { IGetSummary, IGetSummaryVariables } from './types'

/**
 * Hook declaration to obtain a get summary lazy query.
 * @param options: LazyQueryHookOptions without the fetch-policy keys
 * @internal
 */
export const useLazyGetSummary = (
  options?: Omit<
    LazyQueryHookOptions<IGetSummary, IGetSummaryVariables>,
    'fetchPolicy' | 'nextFetchPolicy' | 'initialFetchPolicy'
  >,
) => {
  return useLazyQuery<IGetSummary, IGetSummaryVariables>(getSummaryQuery, {
    ...options,
    fetchPolicy: 'no-cache',
    // Neutralised beside the pin, not merely omitted from the type: both
    // survive the spread otherwise, and `nextFetchPolicy` would take over
    // from the second fetch onward.
    nextFetchPolicy: undefined,
    initialFetchPolicy: undefined,
  })
}

export default useLazyGetSummary
